/*
Solid Surface

--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Solid Surface'
const id = 'KDQemMtVQVtgCAOHKwpV'

export default {
  name,
  id,
  filters,
  headers,
  form
}
